import React from 'react';
import { BackButton } from '../../../../../shared/components/button/BackButton';
import { priceSplitter } from '../../../../../utils/helpers/priceSplitter';
import { useTranslation } from 'react-i18next';

export interface IArchiveHeader {
    totalEarnings: number;
    outstandingEarnings: number;
    activeCampaigns: number;
    completedCampaigns: number;
}
interface IArchiveHeaderProps {
    invoicesTotals: IArchiveHeader;
}

const InvoiceArchiveHeader = ({ invoicesTotals }: IArchiveHeaderProps) => {
    const { t } = useTranslation();
    return (
        <>
            <div className="d-md-flex align-items-center justify-content-between">
                <div className="d-flex align-items-center mb-md-3">
                    <BackButton />
                    <h6 className="mb-0">{t('influencer.invoice.invoice_upload')}</h6>
                </div>
                <div className="d-md-flex">
                    <div className="d-flex my-2 my-md-0">
                        <div className="default-border-lighter default-radius p-2 mr-2 text-center w-50 w-md-auto">
                            <h6 className="mb-0 text-primary">{invoicesTotals.activeCampaigns}</h6>
                            <p className="mb-0">{t('influencer.invoice.active_camp')}</p>
                        </div>
                        <div className="default-border-lighter default-radius p-2 mr-2 text-center w-50 w-md-auto">
                            <h6 className="mb-0 text-primary">{invoicesTotals.completedCampaigns}</h6>
                            <p className="mb-0">{t('influencer.invoice.completed_camp')}</p>
                        </div>
                    </div>

                    <div className="d-flex mb-3 mb-md-0">
                        <div className="default-border-lighter default-radius p-2 mr-2 text-center w-50 w-md-auto">
                            <h6 className="mb-0 text-primary euro-symbol">
                                {priceSplitter(invoicesTotals?.totalEarnings ?? 0)}
                            </h6>
                            <p className="mb-0">{t('influencer.invoice.total_earnings')}</p>
                        </div>
                        <div className="default-border-lighter default-radius p-2 mr-2 text-center w-50 w-md-auto">
                            <h6 className="mb-0 text-primary euro-symbol">
                                {priceSplitter(invoicesTotals?.outstandingEarnings ?? 0)}
                            </h6>
                            <p className="mb-0">{t('influencer.invoice.outstanding_earnings')}</p>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

export default React.memo(InvoiceArchiveHeader);
